import { Avatar, Box, Button, Checkbox, Chip, CircularProgress, Paper, Stack, TableSortLabel, Tooltip, Typography } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, } from 'react-router-dom'
import SearchInput from '../../components/inputs/searchInput';
import { styled } from '@mui/material/styles';
import { getFixedValue, INSTAGRAM_TYPE_WITH_CAPS, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, YOUTUBE_TYPE_WITH_CAPS } from '../../utils/constant';
import { visuallyHidden } from "@mui/utils";
import { getInfluencerListFordashboard } from '../dashboard/action';
import { updateDashboard } from '../dashboard/dashboardSlice';
import { DELIVERABLES_DATA, formatDate, SELECTED_DELI, SELECTED_DELI_FOR_YOUTUBE, setSearchdata } from '../../utils/common';
import deleteIcon from '../../assets/images/icons/trash.svg'
import DeleteModal from '../../components/dialog/DeleteModal';
import CampaignListingModal from '../../components/dialog/CampaignListingModal';
import CreateCampaignModal from '../../components/dialog/CreateCampaignModal';
import { getCampaignByIdForDetailsPage } from '../campaigns/action';
import { updateCampaign } from '../campaigns/campaignSlice';
import { useAddCampaignInfluencersFromWishlistMutation, useDeleteWishlistInfluencersMutation } from '../../redux/api';
import CustomizedSnackbars from '../../components/snackbar';
import { TableVirtuoso } from 'react-virtuoso';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { updateWishlist } from './wishlistSlice';
import stars from '../../assets/images/icons/stars.png'
import bglist from '../../assets/images/icons/listplaceholder.png'
const CustomSearchInput = styled(SearchInput)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "50px !important",
  },
  "& input": {
    padding: '0px !important', paddingLeft: '0px !important'
  }
});
const WishlistInfluncersListing = ({checkIfNoListIsAvailabel, isFetching,isInfluencerListApiCalling , totalCount = 0, influencerList = [], wishlistId, isLoading, page, setPage, limit, setInfluencerSearch, influencerSearch, hasMore, setHasMore, currentPage, loadMore }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deleteWishlistInfluencers] = useDeleteWishlistInfluencersMutation();
  const [addCampaignInfluencersFromWishlist] = useAddCampaignInfluencersFromWishlistMutation()
  const { wishlistList, wishlistInfluncers } = useSelector(state => state.wishlistSlice);
  const { filters, selectedInfluencers } = useSelector(state => state.dashboardSlice);
  const {isScreenZoomed} = useSelector(state=>state.commonSlice);
  const { brandsDropdown } = useSelector(state => state.brandSlice)
  const [wishlistDetails] = useState(wishlistList?.find((i) => i?.id === parseInt(wishlistId)));
  const [deleteWishlistModalOpen, setDeleteWishlistModalOpen] = useState(false);
  const [selectedCurrentListInfluencers, setSelectedCurrentListInfluencers] = useState([]);
  const [campaignListingModalOpen, setCampaignListingModalOpen] = useState(false);
  const [openCreateCampaignModal, setOpenCreateCampaignModal] = useState(false);
  const [checkForSelectAll,setCheckForSelectAll] = useState(false);
  function getVirtuosoHeaderRow({ filters, order, orderBy, wishlistInfluncers, selectedCurrentListInfluencers, setSelectedCurrentListInfluencers }) {
    const headCells = [
      {
        id: "profile",
        numeric: false,
        disablePadding: true,
        label: "Profiles",
        type: "",
        width: "120px"
      },
      {
        id: "followers",
        numeric: false,
        disablePadding: true,
        label: filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? "Followers" : "Subscribers",
        type: "", width: "50px"
      },
      {
        id: "avg_likes",
        numeric: false,
        disablePadding: true,
        label: "Avg Likes",
        type: "", width: "50px"
      },
      {
        id: "avg_reel",
        numeric: false,
        disablePadding: true,
        label: filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? "Avg reel views" : "Avg views",
        type: "", width: isScreenZoomed ? "70px" : "60px"
      },
      {
        id: "avg_comment",
        numeric: false,
        disablePadding: true,
        label: "Avg Comment",
        type: YOUTUBE_TYPE_WITH_CAPS, width: "50px"
      },
      {
        id: "ER",
        numeric: false,
        disablePadding: true,
        label: "ER",
        type: INSTAGRAM_TYPE_WITH_CAPS, width: "40px"
      },
      {
        id: "category",
        numeric: false,
        disablePadding: true,
        label: "Category",
        type: "", width: "50px"
      },
      {
        id: "location",
        numeric: false,
        disablePadding: true,
        label: "Location",
        type: "", width: "60px"
      },
      {
        id: "categories",
        numeric: false,
        disablePadding: true,
        label: "Categories",
        type: "", width: isScreenZoomed ? "100px" : "200px"
      }
    ];
    return (
      <TableRow>
        {headCells.filter((headCell) => {
          return headCell.type === "" || headCell.type.toLowerCase() === filters?.platform?.toLowerCase();
        }).map((headCell) => {
          const isSelectedAll = Array.isArray(wishlistInfluncers) && wishlistInfluncers.length > 0 &&
            Array.isArray(selectedCurrentListInfluencers) && selectedCurrentListInfluencers.length > 0 &&
            wishlistInfluncers.every((i) => selectedCurrentListInfluencers.includes(i.id))
          return (
            <TableCell
              width={headCell.width || '100px'}
              component={"th"}
              key={headCell?.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px solid red' }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={() => null}
              >{ }
                {headCell.label === 'Profiles' && <Checkbox
                  checked={isSelectedAll}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setCheckForSelectAll(true);
                      setSelectedCurrentListInfluencers(wishlistInfluncers?.map((i) => i.id))
                    } else {
                      setCheckForSelectAll(false);
                      setSelectedCurrentListInfluencers([])
                    }
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />}&nbsp;{headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    );
  }
  const [snackbar, setSnackbar] = useState({
    message: "",
    severity: "success",
    open: false,
  });
  useEffect(() => {
    dispatch(updateCampaign({ formData: {} }));
  }, [])
  const addInfluncersToCurrentList = () => {
    const jsonString = JSON.stringify({ platform: "Instagram", categories: [] });
    setSearchdata(jsonString);
    dispatch(
      updateDashboard({
        filters: { platform: "Instagram", categories: [] },
        search: "",
        list: [], limit: limit || 20, totalCount: 0, page: 1, showLoading: true,
      }),
    );
    dispatch(getInfluencerListFordashboard());
    let url = '/list/listing';
    if(wishlistId){
      url+=`?wishlistId=${wishlistId}`
    }
    navigate(url);
  }
  const handleDeleteInfluncersFromWishlist = async () => {
    try {
      const res = await deleteWishlistInfluencers({ wishlistId: wishlistId, influncersList: selectedCurrentListInfluencers,checkForSelectAll }).unwrap();
      setCheckForSelectAll(false);
      if (res.status === "SUCCESS") {
        setSnackbar({
          message: res.message,
          severity: "success",
          open: true,
        });
        setDeleteWishlistModalOpen(false);
        setSelectedCurrentListInfluencers([]);
        dispatch(updateWishlist({
          wishlistInfluncers: []
        }));
      } else {
        setSnackbar({
          message: res.message,
          severity: "error",
          open: true,
        });
      }
    } catch (error) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
        open: true,
      });
    }
  }
  const handleAddInfluncersToCampaignsFromCurrentList = async (campaignId = null) => {
    try {
      const res = await addCampaignInfluencersFromWishlist({ campaignId: campaignId, influncersList: selectedCurrentListInfluencers, status: "ADDED",checkForSelectAll,wishlistId, }).unwrap();
      setCheckForSelectAll(false);
      if (res?.status === "SUCCESS") {
        setSnackbar({
          message: res.message,
          severity: "success",
          open: true,
        });
        setSelectedCurrentListInfluencers([]);
        setCampaignListingModalOpen(false);
      } else {
        setSnackbar({
          message: res.message,
          severity: "error",
          open: true,
        });
      }
    } catch (error) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
        open: true,
      });
    }
  }
  const updateFormData = (row) => {
    dispatch(getCampaignByIdForDetailsPage(row.id, (data) => {
      delete data.campaignContent;
      delete data.applied;
      delete row.applied;
      let rowData = data;
      rowData.campaignId = row.id;
      const selectedDeliverables = rowData?.deliverables?.length > 0 ? (rowData?.deliverables[0]?.plateform === "youtube" ? SELECTED_DELI_FOR_YOUTUBE : SELECTED_DELI).map((vv) => {
        let val = data?.deliverables?.map((v) => v.deliverables)[0]?.find((v) => v?.type == vv?.type);
        if (val) {
          return { ...val };
        }
      }) : [];
      rowData.platform = rowData?.deliverables?.length > 0 ? rowData?.deliverables[0]?.plateform : "";
      rowData.selectedDeliverables = rowData?.deliverables?.length > 0 ? selectedDeliverables : [];
      rowData.post = rowData?.deliverables?.length > 0 ? data?.deliverables[0]?.post : [];
      rowData.deliverables = rowData?.deliverables?.length > 0 ? DELIVERABLES_DATA.find((v) => v[`${rowData.deliverables[0].plateform}`])[`${rowData.deliverables[0].plateform}`] : [];
      rowData.brandId = row?.brandId || rowData?.brand?.id || '';
      rowData.additionalRequirement = rowData.additionalRequirement !== "null" ? rowData.additionalRequirement : "";
      rowData.startDate = rowData.startDate ? formatDate(rowData.startDate) : null;
      rowData.endDate = rowData.endDate ? formatDate(rowData.endDate) : null;
      rowData.budgetbudgetPerInfluencer = rowData.budgetPerInfluencer;
      rowData.gender = rowData?.creator?.gender || "";
      rowData.creatorLocation = rowData?.creator?.creatorLocation || '';
      rowData.influncerType = rowData?.creator?.influncerType || "";
      rowData.selectedCategories = rowData?.creator?.selectedCategories || [];
      rowData.campaignApplyingPreferences = rowData?.creator?.campaignApplyingPreferences ? ['campaignApplyingPreferences'] : [];
      rowData.noOfCreators = String(rowData?.noOfCreators || "");
      rowData.bannerImage = rowData?.bannerImage?.toString() || '';
      rowData.shipmentDetails = rowData.shipmentDetails ? ['shipmentDetails'] : []
      rowData.productShipmentDate = rowData.productShipmentDate && rowData.productShipmentDate !== "0000-00-00" ? formatDate(rowData.productShipmentDate) : "";
      rowData.conceptScriptDate = rowData?.conceptScriptDate ? formatDate(rowData?.conceptScriptDate) : null;
      rowData.contentSubmissionDate = rowData?.contentSubmissionDate ? formatDate(rowData?.contentSubmissionDate) : null
      rowData.contentPublishDate = rowData?.contentPublishDate ? formatDate(rowData?.contentPublishDate) : null;
      rowData.mode = "edit";
      rowData.applyBydate = rowData?.applyBydate ? formatDate(rowData?.applyBydate) : null;
      rowData.productDropdown = brandsDropdown?.find((v) => v.id === rowData.brandId)?.product?.map((v) => v?.name) || [];
      dispatch(updateCampaign({ affliateSection: 0, deliverablesSection: 0, addtionalSection: 0, detailsSection: 0, formData: rowData }));
    }))
  }
  const handleOpenCreateCampaignModal = (campaignId = null) => {
    if (campaignId) {
      updateFormData({ id: campaignId })
    }
    setCampaignListingModalOpen(false);
    setOpenCreateCampaignModal(true);
  }
  useEffect(() => {
    if (wishlistInfluncers?.length >= totalCount) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }, [wishlistInfluncers?.length, totalCount, setHasMore]);
  const MemoizedTable = useCallback((props) => (
    <Table stickyHeader {...props} sx={{ tableLayout: 'fixed', width: '100%' }} />
  ), []);
  const MemoizedTableRow = useCallback((props) => (
    <TableRow
      sx={{
        "&:hover": {
          backgroundColor: '#F0F7FF !important',
          "& td": { backgroundColor: "inherit !important" },
        },
        height: '60px',
      }}
      {...props}
      hover
    />
  ), []);
  const headerContent = useMemo(() =>
    getVirtuosoHeaderRow({ filters, order: "asc", orderBy: "name", wishlistInfluncers, selectedCurrentListInfluencers, setSelectedCurrentListInfluencers }),
    [filters, selectedCurrentListInfluencers, wishlistInfluncers]
  );
  const footer = useCallback(
    () => {
      return (
        <>{isLoading && <TableRow>
          <TableCell colSpan={9} align="center">
            <CircularProgress sx={{
              color: 'rgba(200, 80, 192, 1)',
            }} size={40} />
          </TableCell>
        </TableRow>}</>
      )
    },
    [isLoading],
  )
  const footerContent = useMemo(() => footer(), [footer]);
  const renderItemContent = useCallback((index, row) => {
    let categories = JSON.parse(row?.profileNiche || "[]")?.length > 0 ? JSON.parse(row?.profileNiche)?.map((v) => ({ title: v?.option, id: v.id })) : [];
    return (
      <><TableCell component="td" scope="row">
        <Stack direction={"row"} spacing={2}>
          <div class="MuiAvatar-root MuiAvatar-circular css-1nn861f-MuiAvatar-root" style={{ display: 'flex', border: '0px solid red', width: 'fit-content', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
            <Checkbox
              checked={(selectedCurrentListInfluencers || [])?.includes(row?.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedCurrentListInfluencers((prev) => [...prev, row?.id]);
                  dispatch(updateDashboard({ selectedInfluencers: [...selectedInfluencers, row] }));
                } else {
                  setSelectedCurrentListInfluencers((prev) => prev.filter((i) => i !== row?.id));
                  dispatch(updateDashboard({ selectedInfluencers: selectedInfluencers?.filter((i) => i?.id !== row?.id) }));
                }
              }}
              inputProps={{ 'aria-label': 'controlled' }} />
            <img alt="" style={{ height: '35px', width: '35px', borderRadius: "100px" }} src={row?.picture ? row?.picture : "/profile.jpg"} className="MuiAvatar-img" />
          </div>
          <Link className="text-decoration-none" target='_blank' style={{ fontSize: '13px', paddingTop: 7, fontWeight: '500', letterSpacing: '0px' }} onClick={(e) => {
            e.preventDefault();
            window.open("/userManagement/details/" + row.id, '_blank');
          }}>{row?.name}</Link>
        </Stack>
      </TableCell><TableCell component="td" scope="row">
          {getFixedValue(row?.followers) || "N/A"}
        </TableCell><TableCell component="td" scope="row">
          {getFixedValue(row?.Engagement?.posts?.avg_likes) || "N/A"}
        </TableCell><TableCell align="left">
          {filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? getFixedValue(row?.Engagement?.reels?.avg_views) : getFixedValue(row?.Engagement?.posts?.avg_views) || "N/A"}
        </TableCell>
        {filters?.platform === INSTAGRAM_TYPE_WITH_CAPS && <TableCell align="left">
          {getFixedValue(row?.Engagement?.posts?.engagement_rate) || "N/A"}
        </TableCell>}
        {filters?.platform === YOUTUBE_TYPE_WITH_CAPS && <TableCell align="left">
          {getFixedValue(row?.Engagement?.posts?.avg_comments) || 'N/A'}
        </TableCell>}
        <TableCell align="left">
          {row?.creatorCategory || "N/A"}
        </TableCell>
        <TableCell align="left">
          {row?.location ?
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "rgba(97, 97, 97, 0.9) !important",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "500",
                    padding: "5px !important",
                    borderRadius: "6px",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(97, 97, 97, 0.9) !important",
                    "&::before": {
                      backgroundColor: "rgba(97, 97, 97, 0.9)",
                    },
                  },
                },
              }}
              title={row?.location}
              arrow={true}
            >
              {row?.location.toString().length > 20 ? row?.location?.slice(0, 20) + '...' : row?.location}
            </Tooltip>
            : "N/A"}
        </TableCell>
        <TableCell align="left" >
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
            {categories?.map((option, index) => (
              <>     {option?.title ?
                <Tooltip
                  title={option?.title}
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "rgba(97, 97, 97, 0.9) !important",
                        color: "white",
                        fontSize: "12px",
                        fontWeight: "500",
                        padding: "5px !important",
                        borderRadius: "6px",
                        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "rgba(97, 97, 97, 0.9) !important",
                        "&::before": {
                          backgroundColor: "rgba(97, 97, 97, 0.9)",
                        },
                      },
                    },
                  }}
                >
                  <Chip
                    key={option?.id}
                    label={option?.title?.length > 20 ? option?.title?.slice(0, 20) + '...' : option?.title}
                    avatar={<Avatar alt={option.title} src={`/influncersCategoryIcons/category_icon_${option.id}.svg`} sx={{ height: '20px !important', width: '20px !important' }} />}
                    sx={{
                      display: (index > 1 ? "none" : "flex"),
                      flexDirection: 'row',
                      background: 'white !important', color: '#726C6C !important',
                      borderRadius: '62px', border: '1px solid #CCCBCB', fontSize: '12px', fontWeight: '500',
                      padding: "2px 8px", height: '32px', "&:hover": {
                        background: 'rgba(0, 0, 0, 0.04) !important',
                      }
                    }}
                  /></Tooltip> : "NA"}
              </>
            ))}
          </div>
        </TableCell>
      </>
    );
  }, [dispatch, filters?.platform, selectedCurrentListInfluencers, selectedInfluencers]);
  const handleSearch = (e) => {
    setInfluencerSearch(e.target.value);
    setPage(0)
    dispatch(updateWishlist({ wishlistInfluncers: [] }))
  }
  return (
    <>
      <CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} />
      <Stack sx={{ paddingX: '16px', position: 'relative' }} direction={{ xs: 'column', sm: "row" }} gap={{ xs: 2, sm: 0 }} justifyContent="space-between" alignItems="start">
       {!checkIfNoListIsAvailabel&& <Stack direction="Column" justifyContent="flex-start" alignItems="flex-start" gap={2} flexWrap="wrap" >
          <CustomSearchInput
            className="inputSearch sContrl p-0 "
            value={influencerSearch}
            sx={{
              width: '300px'
            }}
            placeholder={"Search here..."}
            handleSearch={(e) => { handleSearch(e) }}
            clearSearch={() => { setInfluencerSearch("") }}
            startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT}
          />
          {totalCount>0 && <Stack direction={"row"} justifyContent={"flex-start"} pb={2}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'var(--color-blue)' }}>
              {wishlistInfluncers.length === 0 ? 0 : totalCount || 0} Creators&nbsp;
            </Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C' }}>
              in this list
            </Typography>
          </Stack>}
        </Stack>}
        <Stack direction={{ xs: "row-reverse", sm: "row" }} justifyContent={{ xs: 'flex-start', sm: "flex-end" }} alignItems="center" gap={2} flexWrap="wrap">
          {selectedCurrentListInfluencers?.length > 0 && <Button sx={{
            borderRadius: '10px', position: 'relative',
            border: '0px solid red',
            background: 'var(--red)',
            color: 'white',
            padding: { xs: '10px', sm: '10px 20px' }, fontWeight: '600', fontSize: '16px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            overflow: 'hidden', "&:hover": { background: 'var(--red)', border: '0px' }
          }}
            onClick={() => {
              setDeleteWishlistModalOpen(true)
            }}>
            <img src={deleteIcon} style={{ width: '18px', height: '18px' }} alt="trash" /><Typography sx={{
              display: { xs: 'none', sm: 'inline-block' },
              background: 'transparent', borderRadius: '8px', color: 'white', fontWeight: '600', fontSize: '16px', "&:hover": { background: 'var(--red)', border: '0px' }
            }}>
              &nbsp;Delete
            </Typography>
          </Button>}
          {!checkIfNoListIsAvailabel && <Button disabled={!wishlistId} onClick={() => addInfluncersToCurrentList()} sx={{ background: !wishlistId ? 'var(--draft)' : 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '0', borderRadius: '10px', margin: '0px' }}><Typography sx={{ color: !wishlistId ? 'white' :  '#000', margin: '2px', borderRadius: '9px', padding: { xs: '10px', sm: '10px 20px' }, width: '100%', height: '100%', fontSize: "16px", background: !wishlistId ? 'var(--draft)' :  'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, "&:hover": { background: 'transparent', color: 'white' } }}>Add Influncers
          </Typography></Button>}
          <Button onClick={() => setCampaignListingModalOpen(true)} disabled={selectedCurrentListInfluencers?.length <= 0} sx={{ display:'none',background: selectedCurrentListInfluencers?.length <= 0 ? 'var(--draft)' : 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '0', borderRadius: '10px', margin: '0px' }}><Typography sx={{ color: 'white', margin: '2px', borderRadius: '9px', padding: { xs: '10px', sm: '10px 20px' }, width: '100%', height: '100%', fontSize: "16px", background: selectedCurrentListInfluencers?.length <= 0 ? 'var(--draft)' : 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, "&:hover": { background: 'transparent', color: 'white' } }}>Move To Campaign
          </Typography></Button>
        </Stack>
      </Stack>
      <Box
        sx={{
          backgroundColor: '#fff',
          transition: 'all .5s ease-in-out',
          position: 'relative',
          border: 0,
          borderRadius: '0px',
        }}>
    {(wishlistInfluncers.length > 0 && !checkIfNoListIsAvailabel) ?     <Paper sx={{ width: '100%', height: isScreenZoomed  ? "77vh" : "81vh", border: 0,boxShadow:0 }}>
          {<TableVirtuoso
            data={wishlistInfluncers || []}
            style={{
              overflowY: 'scroll',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
            endReached={() => {
              if (!isLoading && hasMore) loadMore();
            }}
            context={{ isLoading, }}
            components={{
              Table: MemoizedTable,
              TableBody: TableBody,
              TableRow: MemoizedTableRow,
            }}
            fixedHeaderContent={() => headerContent}
            fixedFooterContent={() => footerContent}
            itemContent={(index, row) => {
              return (renderItemContent(index, row))
            }}
          />}{isLoading && (
            <div style={{ textAlign: "center", padding: 16 }}>
              <CircularProgress size={24} />
            </div>
          )}
        </Paper> : <>
      {(!isFetching && !isInfluencerListApiCalling) &&  <Stack height={"100%"} direction={"column"} justifyContent="center" alignItems={"center"} gap={2}>
            <Stack height={"50%"} direction={"column"} justifyContent="center" alignItems={"center"} gap={4}>
              <img src={stars} alt="stars" style={{ height: '48px', width: '48px' }} />
              <Box>
                <Typography fontSize={24} fontWeight={700} color={"black"} textAlign={"center"}>Add Creator to List</Typography>
                <Typography fontSize={14} fontWeight={400} color={"#726C6C"} textAlign={"center"}>Create your first list to get started.</Typography>
              </Box>
              <Button
                sx={{
                  borderRadius: '10px', position: 'relative', background:'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden',
                }}
                onClick={() => addInfluncersToCurrentList()} >
                <Typography sx={{
                  padding: '10px 20px', background:'white', borderRadius: '8px', color: '#000000', fontWeight: '600', fontSize: '16px', height: '100%', "&:hover": { background: 'transparent', color: 'white' }
                }}>
                  Add Creator
                </Typography>
              </Button>
            </Stack>
            <img src={bglist} alt="" />
          </Stack>}
        </>}
      </Box>
      <DeleteModal handleDelete={handleDeleteInfluncersFromWishlist} open={deleteWishlistModalOpen} setOpen={setDeleteWishlistModalOpen} title={`Delete ${selectedCurrentListInfluencers?.length || 'Selected'} Influncers from the ${wishlistDetails?.listName?.substring(0, 10) || 'Current List'}`} subHeading={`Are you sure you want to delete ${selectedCurrentListInfluencers?.length || 'Selected'} Influncers from ${wishlistDetails?.listName?.substring(0, 10) || 'Current List'}`} />
      <CampaignListingModal handleOpenCreateCampaignModal={handleOpenCreateCampaignModal} handleAddInfluncersToCampaignsFromCurrentList={handleAddInfluncersToCampaignsFromCurrentList} open={campaignListingModalOpen} setOpen={setCampaignListingModalOpen} title={`Delete ${selectedCurrentListInfluencers?.length || 'Selected'} Influncers from the ${wishlistDetails?.listName?.substring(0, 10) || 'Current List'}`} subHeading={`Are you sure you want to delete ${selectedCurrentListInfluencers?.length || 'Selected'} Influncers from ${wishlistDetails?.listName?.substring(0, 10) || 'Current List'}`} />
      <CreateCampaignModal handleAddInfluncersToCampaignsFromCurrentList={handleAddInfluncersToCampaignsFromCurrentList} influncersList={selectedCurrentListInfluencers} open={openCreateCampaignModal} setOpen={setOpenCreateCampaignModal} />
    </>
  )
}
export default WishlistInfluncersListing;
